import React from "react";

const Work = () => {
  return (
    <div className="w-10/12 mx-auto mt-16" id="work">
      <p className="text-center text-gray-700 text-lg">Explore my</p>
      <p className="text-center text-gray-700 text-2xl underline mb-8">
        Work Experience
      </p>
      <div className="flex flex-wrap justify-around">
        <div className="w-96 rounded-lg m-2 p-2 border border-black">
          <p className="font-bold text-2xl m-1 p-1">Accenture in India</p>
          <p className="text-lg font-semibold m-1 p-1">
            Senior Software Engineer
          </p>
          <p className="text-sm text-slate-700 m-1 p-1">Jul 2024 - Present</p>
          <p className="text-sm text-slate-700 m-1 p-1">
            <ul className="list-disc pl-2 ml-2">
              <li>
                Supply Chain Domain:- Migrated multiple legacy features into
                React microfrontends (MFE) with modular, scalable architecture,
                improving maintainability and deployment flexibility.
              </li>
              <li>
                - Developed an admin portal using React with Redux Toolkit and
                Redux Saga for efficient state management, enabling seamless
                data flow and side-effect handling.- Built an RBAC-driven order
                management MFE integrated with i18next (i18n) for multi-language
                support and CMS-based configuration for dynamic content
                management.
              </li>
              <li>
                - Developed an order tracking MFE featuring multi-filter search,
                mass actions, and persistent user preferences for enhanced UX.-
                Created a logistics scheduling MFE with full CRUD template
                management covering shifts, vehicles, and resources.
              </li>
              <li>
                - Leveraged GitHub Copilot to accelerate development speed, unit
                test authoring, and improve test coverage across MFE modules.-
                Resolved multiple Node.js backend bugs including CRQ validation
                logic, incorrect API response handling, and various production
                issues, ensuring system stability and reliability.
              </li>
              <li>
                - Integrated Redis with Node.js backend to store and manage
                session IDs, improving session handling performance and
                scalability.- Familiar with Docker and Jenkins; actively
                learning Kubernetes (K8s) for containerized deployments in a
                microservices environment.
              </li>
            </ul>
          </p>
        </div>

        <div className="w-96 rounded-lg m-2 p-2 border border-black">
          <p className="font-bold text-2xl m-1 p-1">
            Tata Consultancy Services
          </p>
          <p className="text-lg font-semibold m-1 p-1">System Engineer</p>
          <p className="text-sm text-slate-700 m-1 p-1">
            April 2021 - Jul 2024
          </p>
          <p className="text-sm text-slate-700 m-1 p-1">
            <ul className="list-disc pl-2 ml-2">
              <li>
                E-Commerce Domain:- Developed React-based microsites with a
                focus on responsive design, modular architecture, and reusable
                UI component libraries.
              </li>
              <li>
                - Optimized application performance and ensured cross-browser
                compatibility; tech stack: React, JavaScript, HTML5, CSS3.
              </li>
              <li>
                Payment Application Domain (RTGS):- Conducted regression and
                performance testing, generating reports Conducted regression and
                performance testing, generating reports and insights on payment
                data using SQL queries.
              </li>
              <li>
                - Provided production support for the RTGS application,
                including DR drills, production data archival, and
                post-deployment sanity testing
              </li>
              <li>Skills:-Reactjs, Javascript, Amplience CMS</li>
            </ul>
          </p>
        </div>

        <div className="w-96 rounded-lg m-2 p-2 border border-black">
          <p className="font-bold text-2xl m-1 p-1">Tech Mahindra Ltd</p>
          <p className="text-lg font-semibold m-1 p-1">Associate</p>
          <p className="text-sm text-slate-700 m-1 p-1">Sep 2019 - Apr 2021</p>
          <p className="text-sm text-slate-700 m-1 p-1">
            <ul className="list-disc pl-2 ml-2">
              <li>Telecom Domain</li>
              <li>
                Displayed a commitment to team development by providing
                comprehensive training and support to new team members,
                fostering a highly collaborative work environment
              </li>
            </ul>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Work;
